module.exports = __webpack_public_path__ + "img/logo-white.2767dea1.svg";